module.exports = "/images/5627f749520630c54bd9276b0101a867.svg";